import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @element kd-scroll-to-top
 * @description 配下要素のクリックでページ最上部へスムーススクロールする。
 */
@customElement('kd-scroll-to-top')
export class KdScrollToTop extends LitElement {
  createRenderRoot() {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.removeEventListener('click', this.handleClick);
  }

  private handleClick = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-scroll-to-top': KdScrollToTop;
  }
}
